export const WORKSITE_DESC_MAX_CHARS = 100;
export const COUNTRY_CODES_MAPPINGS: Record<string, string> = {
  it: "ITA",
  es: "ESP",
}